import { createFileRoute, getRouteApi } from "@tanstack/react-router";
import {
  convertDateToYYYYMMDD,
  getBeginningStatisticsDate,
  getToday,
} from "../../../../helpers/time.helpers";
import GroupDrivingHistoryPage from "../../../../pages/GroupPage/GroupDrivingHistoryPage/GroupDrivingHistoryPage";

export const Route = createFileRoute("/(app)/groups/$id/driving-history")({
  component: RouteComponent,
  validateSearch: (
    search: Record<string, any>
  ): {
    v: string[];
    selectAll: boolean;
    range: [string | null, string | null];
  } => ({
    v: search.v || [],
    selectAll: (search.selectAll as boolean) || false,
    range: [
      search.range?.[0]
        ? search.range[0]
        : convertDateToYYYYMMDD(getBeginningStatisticsDate()),
      search.range?.[1] ? search.range[1] : convertDateToYYYYMMDD(getToday()),
    ],
  }),
});

const routeApi = getRouteApi("/(app)/groups/$id");

function RouteComponent() {
  const group = routeApi.useLoaderData();
  return <GroupDrivingHistoryPage group={group} />;
}
